import { MRT_ColumnDef } from 'mantine-react-table';
import { Text } from '@mantine/core';
import type { CSSProperties } from 'react';
import { formatDateToShow, stringToDate } from 'app/utils/util-functions';

const getTextStyle = (weight: number, color: string): CSSProperties => ({
    fontFamily: 'Plus Jakarta Sans',
    fontSize: '18px',
    fontWeight: weight,
    lineHeight: '32px',
    textAlign: 'start',
    color: color,
    width: '100%',
});

function TableHead({ header }: { header: string, }) {
    return (
        <Text style={getTextStyle(400, "#784595")}>
            {header}
        </Text>
    );
}

export const gridHolidaySummaryColumnDefs: MRT_ColumnDef<any>[] = [
    {
        header: 'Name',
        accessorKey: 'holidayName',
        mantineTableHeadCellProps: {
            className: 'cell-width-100',
        },
        Header: () => (
            <TableHead header={'Calendars'} />
        ),
        Cell: ({ cell }) => {
            return (
                <div>
                    <Text style={{ ...getTextStyle(500, '#476DB9') }}>
                        {cell.getValue<string>()}
                    </Text>
                </div >
            );
        },
    },
    {
        header: 'Date',
        accessorKey: 'holidayDate',
        Header: () => (
            <TableHead header={'Dates'} />
        ),
        Cell: ({ cell }) => {
            const value = cell.getValue<string>();
            const date = formatDateToShow(value ? stringToDate(value) : undefined)

            return (
                <div>
                    <Text style={{ ...getTextStyle(500, '#476DB9') }}>
                        {date}
                    </Text>
                </div>
            );
        },

    }
];
